import * as _ from 'lodash'
import orgamax from 'ampersand-app'

export default function(window) {
  // set environment variables
  const releaseStage = ENV.releaseStage || 'development'

  orgamax.extend({
    releaseStage,
    version: _.get(window, 'settings.version') || require('./../../../package.json').version,
    buildTarget: window._buildTarget || 'orgamax',
  })

  // remove settings written at deploy-time from global object
  delete window.settings
  delete window._buildTarget
  document.getElementById('buildTarget_js').remove()
}
